import Navigation from './navigation.js';
Navigation();

import './modal.js';

import './wpcf7';


let fileInputs = document.querySelectorAll( '.contactForm-fileUpload' );

[].forEach.call( fileInputs, ( node ) =>
{

	let input = node.querySelector('input'),
		label = node.querySelector('label'),
		labelVal = label.innerHTML;

		input.addEventListener( 'change', function( e ){
			let fileName = '';

			fileName = e.target.value.split( '\\' ).pop();

			

			if(fileName){
				label.innerHTML = fileName;
				node.classList.add('contactForm-fileUpload_hasFile');
			}else{
				label.innerHTML = labelVal;
				node.classList.remove('contactForm-fileUpload_hasFile');
			}
		});
});


let projectsListItems = Array.prototype.slice.call(document.querySelectorAll( '.projectsList-item_list' )),
	projectsListCategoriesControls = Array.prototype.slice.call(document.querySelectorAll( '.projectsList-categoriesControls > button' ));

projectsListCategoriesControls.forEach( ( control ) => {

	control.addEventListener('click', ()=>{
		
		projectsListCategoriesControls.forEach( ( _control ) => {

			if( _control!=control ) {
				_control.disabled = false;
			}else {
				_control.disabled = true;
			}
		});

		projectsListItems.forEach( ( item ) => {

			if( control.dataset.categoryslug =='all' ) {

				item.style.removeProperty('display');

			} else if (item.dataset.categoryslugsarr.indexOf( control.dataset.categoryslug ) < 0) {

				item.style.display='none';
			} else {

				item.style.removeProperty('display');
			}
		});
	});
});